import React, {useEffect, useState} from 'react';

const PrivacyPage = () => {
    const [privacyPolicy, setPrivacyPolicy] = useState<string | null>(null);

    useEffect(() => {
        fetch('/privacy-policy.html')
            .then((response) => response.text())
            .then((data) => setPrivacyPolicy(data))
            .catch((error) => console.error('Error fetching privacy policy:', error));
    }, []);

    return (
        <div className="App">
            {privacyPolicy ? (
                <div dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
};


export default PrivacyPage;